import React, { useContext } from "react"
import { TrulyGlobalWrapper } from "./TrulyGlobal.styles"
import { Container } from "react-bootstrap"
import { MapContext } from "./LogosMap"
import Logos from "./logos/logos"

const TrulyGlobal = () => {
  const [state, setState] = useContext(MapContext);

var logoImages = '';


  if (state.mode === 'ACQ') {
    switch (state.location) {
      case 'Africa':
        logoImages = <Logos logoImages={["Barclays","FirstData","arabAfricanInterBank","worldPay","americanExpress","i&mBank","bitpay","paypal","skrill","access","zenith","firstRandBank","absa","ubas","bidvest","paysera","kcb","nbc"]}/>
        break;
      case 'Asia':
        logoImages = <Logos logoImages={['payeco','credorax','FirstData','worldPay','acgriculturalChina','americanExpress','pinganbank','globalpayments','bea','bocInternational','hsbc','ocbcWingHang','wingLungBank','citi','axisBank','hdfcBank','iciciBank','yesBank','jbc','omc','life','nicos','orico','saisonInsurance','sumitomoLife','toyota','bc','keb','citibank','bocHongKong','maybank','bankDhofar','bankMuscat','hbl','unionBank','bsn','ocbcBank','uob','unionBankTaiwan','cathayUnitedBank','taishinBank','smfg','7Eleven']}/>
        break;
      case 'Europe':
        logoImages = <Logos logoImages={['payplug','elavon','ingenicoGroup','bambora','six','barclaycard','paysafe','aib','borgun','cashflows','credorax','lloydsBank','evo','FirstData','hsbc','ecp','payvision','trustpay','postbank','cm-cic','merchantServices','worldPay','processingCom','transactEurope','trueevo','americanExpress','BNL','ems','bankOfAmerica','rbs','atticaBank','societeGenerale','worldLine']}/>
        break;
      case 'North America':
        logoImages = <Logos logoImages={['elavon','barclaycard','credorax','evo','FirstData','globalpayments','processingCom','worldPay','americanExpress','bankOfAmerica','capitalOne','delta','farelogix','fdc','jpMorgan','metroBank','cityNationalBank','tsys','vantiv','wellsFargo','azul','bitpay']}/>
        break;
      case 'Oceania':
        logoImages = <Logos logoImages={['worldPay','americanExpress','FirstData','nationalAustraliaBank','anz','boq','citibank','globalpayments','jpMorganChaseCo','nab','westpac','bni','bca','cimaNiaga','bankBri','asb','7Eleven']}/>
        break;
      case 'South America':
        logoImages = <Logos logoImages={['mcb','FirstData','cielo','worldPay','americanExpress','lloydsBank','bancoSafra','braspag','bancoPromerica','banamex','bbva','bancoGeneral','visaNet','scotiabank','7Eleven']}/>
        break;
      default:
        logoImages = ''
        break;
    }
  } else if (state.mode === 'APM') {
    switch (state.location) {
      case 'Africa':
        logoImages = <Logos logoImages={[
          'applePay',
          'banContact',
          'bitpay',
          'payconiq',
          'paypal',
          'paysafeCard',
          'paysafecash',
          'paze',
          'skrill',
          'affirm',
          'sezzle'
        ]}/>
        break;
      case 'Asia':
        logoImages = <Logos logoImages={[
          'alipay',
          'applePay',
          'banContact',
          'dragonPay',
          'paypal',
          'paysafeCard',
          'unionpay',
          'wechatPay',
          'atome',
          'bitpay',
          'boost',
          'doku',
          'fpxOnlineBanking',
          'gopayByGojek',
          'grabPay',
          'indomaret',
          'jeniusPay',
          'konbini',
          'kredivo',
          'linkaja',
          'ovo',
          'payEasy',
          'payconiq',
          'paysafecash',
          'paze',
          'touchNGo'
        ]}/>
        break;
      case 'Europe':
        logoImages = <Logos logoImages={[
          'applePay',
          'banContact',
          'blik',
          'ideal',
          'klarna',
          'mbWAY',
          'multibanco',
          'mybank',
          'paypal',
          'paysafeCard',
          'postfinanceEFinance',
          'przelewyP',
          'satispay',
          'sepa',
          'skrill',
          'trustly',
          'swish',
          'zip',
          'clearpay',
          'affirm',
          'sezzle',
          'laybuy',
          'accelPINlessDebit',
          'bancomatPay',
          'bitpay',
          'eps',
          'latviaBanks',
          'lithuaniaBanks',
          'payconiq',
          'paysafecash',
          'paysera',
          'paze',
          'sofort',
        ]}/>
        break;
      case 'North America':
        logoImages = <Logos logoImages={[
          'applePay',
          'paypal',
          'paysafeCard',
          'zip',
          'clearpay',
          'affirm',
          'sezzle',
          'accelPINlessDebit',
          'bitpay',
          'nycePINlessDebit',
          'paysafecash',
          'pulsePINlessDebit',
          'starPINlessDebit',
          'banContact',
          'payconiq',
          'paze',
          'skrill'
        ]}/>
        break;
      case 'Oceania':
        logoImages = <Logos logoImages={[
          'laybuy',
          'sezzle',
          'applePay',
          'banContact',
          'bitpay',
          'payconiq',
          'paypal',
          'paysafeCard',
          'paysafecash',
          'paze',
          'skrill',
          'affirm',
          'sezzle',
        ]}/>
        break;
      case 'South America':
        logoImages = <Logos logoImages={[
          "boletoBancRio",
          "oxxoDirect",
          "pagoFCil",
          "pix",
          "payU",
          "brazilBanks",
          "rapipago",
          "applePay",
          "banContact",
          "bitpay",
          "payconiq",
          "paypal",
          "paysafeCard",
          "paysafecash",
          "paze",
          "skrill",
          "affirm",
          "sezzle",
        ]}/>
        break;
      default:
        logoImages = ''
        break;
    }
  }


  return (
    <TrulyGlobalWrapper className="py-5 px-3">
      <Container className="mt-5">
        <div className="text-center">
          <h2 className="h1 mb-5 font-weight-bold ambit truly-global">Truly Global Processing Locally</h2>
          <p className="mb-5">
            Doing business in new markets is always fraught with complications
            from fulfilment to logistics to legal obstacles etc. APEXX
            specialises in guiding enterprise merchants into new markets. The
            APEXX Gateway offers truly global coverage to local processors in
            the complex new markets that you are trying to enter. Local
            processing helps merchants avoid exorbitant foreign exchange fees on
            their cross-border transactions, as well as boosting the chances of
            acceptance, and avoiding scheme mandated cross-border fees.
          </p>
        </div>

        <div className="filters">
          <div className="filter-item">
            <label htmlFor="region-select" className="mb-0 font-weight-normal primary-blue-text">Find
              Acquirers:</label>
            <select
              id="region-select"
              className="custom-select w-auto"
              value={state.location}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, location: e.target.value, selectContinent: true }))
              }
            >
              <option value="Africa">Africa</option>
              <option value="Asia">Asia</option>
              <option value="Europe">Europe</option>
              <option value="North America">North America</option>
              <option value="Oceania">Oceania</option>
              <option value="South America">South America</option>
            </select>
          </div>

          <div className="filter-item">
            <span className="mb-0 font-weight-normal primary-blue-text">Show:</span>
            <div className="radios" role="radiogroup" aria-label="Show">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="mode-options"
                  id="mode-acq"
                  value="ACQ"
                  checked={state.mode === "ACQ"}
                  onChange={() => setState((prevState) => ({ ...prevState, mode: "ACQ" }))}
                />
                <label className="form-check-label" htmlFor="mode-acq">ACQ</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="mode-options"
                  id="mode-apm"
                  value="APM"
                  checked={state.mode === "APM"}
                  onChange={() => setState((prevState) => ({ ...prevState, mode: "APM" }))}
                />
                <label className="form-check-label" htmlFor="mode-apm">APM</label>
              </div>
            </div>
          </div>
        </div>

        <div id="local-processors">
          {logoImages}
        </div>

      </Container>
    </TrulyGlobalWrapper>
  )
}

export default TrulyGlobal
